module.exports = __webpack_public_path__ + "static/media/dailies.fe37b307.png";